import React, { Component } from 'react';
import PropTypes from 'prop-types';
import JobInfo from './JobInfo';
import { dashboardColumnDateFormat } from '../../../constants/date';

export default class DashboardColumn extends Component {
  static propTypes = {
    dayJobs: PropTypes.array.isRequired,
    dayOfWeek: PropTypes.object.isRequired,
    history: PropTypes.object.isRequired,
    shouldHide: PropTypes.object.isRequired
  };

  render () {
    const { dayJobs, dayOfWeek, history, shouldHide } = this.props;
    return (
      <div className='dashboad-column'>
        <div className='column-header'>
          {dayOfWeek.format(dashboardColumnDateFormat)}
        </div>
        <div className='column-body'>
          { dayJobs.map(job => (
            <JobInfo
              jobData={job}
              key={job.id}
              history={history}
              shouldHide={shouldHide}
            />
          ))}
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/app/dashboard/DashboardColumn.js